import React from "react";

export const FormulIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none">
      <path
        d="M21.3332 12.0001C21.3332 14.4754 20.3498 16.8494 18.5995 18.5997C16.8492 20.3501 14.4752 21.3334 11.9998 21.3334C9.52448 21.3334 7.15051 20.3501 5.40017 18.5997C3.64983 16.8494 2.6665 14.4754 2.6665 12.0001C2.6665 9.52473 3.64983 7.15076 5.40017 5.40042C7.15051 3.65008 9.52448 2.66675 11.9998 2.66675C14.4752 2.66675 16.8492 3.65008 18.5995 5.40042C20.3498 7.15076 21.3332 9.52473 21.3332 12.0001Z"
        stroke="#ABCDEC"
      />
      <path
        d="M10.7012 20.8093C10.5807 19.4251 10.7706 18.0315 11.2573 16.7301C11.744 15.4287 12.5151 14.2523 13.5144 13.2869C14.5136 12.3215 15.7158 11.5914 17.0332 11.1499C18.3506 10.7083 19.75 10.5665 21.1292 10.7347M25.3292 12.3373C26.4498 13.1171 27.3857 14.1332 28.071 15.314C28.7562 16.4948 29.174 17.8115 29.295 19.1713C29.416 20.5312 29.2372 21.901 28.7712 23.1842C28.3052 24.4674 27.5634 25.6328 26.598 26.5981C25.6327 27.5635 24.4673 28.3053 23.1841 28.7713C21.9009 29.2373 20.5311 29.4161 19.1712 29.2951C17.8114 29.1741 16.4947 28.7563 15.3139 28.071C14.1331 27.3858 13.117 26.4499 12.3372 25.3293"
        stroke="#ABCDEC"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.66634 3.3335L20.6663 15.3335M3.33301 8.66683L15.333 20.6668"
        stroke="#ABCDEC"
      />
    </svg>
  );
};
